// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3a5Ug","col":"styles_col__3HU_J","fulfillmentStatus":"styles_fulfillmentStatus__mwqDz","emailCol":"styles_emailCol__3zfUT"};